module.exports = __webpack_public_path__ + "img/aww.5267f049.svg";